import { Button } from '@nest/uikit-react';
import { CircleDashedIcon, SquareDashedIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { TerminalScreen } from '../components/TerminalScreen';

export default function MovePage() {
	const navigate = useNavigate();

	return (
		<TerminalScreen showBackButton backButtonTo="/" topBar={<div>Přesun</div>}>
			<div className="flex flex-col gap-2 p-2">
				<Button variant="outline" size="xl" onClick={() => navigate('/move/handling-unit')} className="w-full flex items-center justify-start gap-2">
					<SquareDashedIcon className="w-4 h-4" />
					Přesun LP
				</Button>
				<Button variant="outline" size="xl" onClick={() => navigate('/move/stock-item')} className="w-full flex items-center justify-start gap-2">
					<CircleDashedIcon className="w-4 h-4" />
					Přesun zboží
				</Button>
			</div>
		</TerminalScreen>
	);
}
